<template>
  <form
    :class="{&quot;loading&quot;: loading}"
    @submit.prevent="submit"
  >
    <x-errors-messages :errors="errors" />
    <slot :loading="loading" />
  </form>
</template>

<script>
  import xErrorsMessages from '@/components/controls/x-errors-messages'

  export default {
    name: 'XForm',
    components: {
      'x-errors-messages': xErrorsMessages
    },
    props: ['request', 'requestErrors'],
    data () {
      return {
        loading: false,
        errors: []
      }
    },
    watch: {
      request () {
        this.loading = true
        this.request.then(() => {
          this.loading = false
        })
          .catch(({fields}) => {
            this.loading = false
            this.errors = fields.global
          })
      },
      requestErrors () {
        this.errors = this.requestErrors
      }
    },
    methods: {
      submit (event) {
        this.$emit('submit', event)
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  form {
    transition: padding-bottom 400ms;
    &.changed {
      padding-bottom: $space-big;

      @media screen and (max-width: $md-breakpoint) {
        padding-bottom: $space-big * 2;
      }
    }
    &.loading {
      input, select, textarea, .button {
        pointer-events: none;
        opacity: 0.8;
      }
    }
  }
</style>
